import React from 'react';

import PropTypes from 'prop-types';

import PromoTrackingWrapper from '~/builder/components/PromoTrackingWrapper/PromoTrackingWrapper';
import { ProductListViewedProvider } from '~/techstyle-shared/react-products';

const GridLayoutTrackingProvider = ({ children }) => {
  return (
    <ProductListViewedProvider>
      <PromoTrackingWrapper>{children}</PromoTrackingWrapper>
    </ProductListViewedProvider>
  );
};

GridLayoutTrackingProvider.propTypes = {
  children: PropTypes.node,
};

export default GridLayoutTrackingProvider;
